// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("fonts/icomoon.eot?w6tg1a", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("fonts/icomoon.ttf?w6tg1a", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("fonts/icomoon.woff?w6tg1a", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("fonts/icomoon.svg?w6tg1a", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___, { hash: "#icomoon" });
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'icomoon';

  src:  url(${___CSS_LOADER_URL_REPLACEMENT_0___});

  src:  url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('embedded-opentype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff'),
    url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('svg');

  font-weight: normal;

  font-style: normal;

  font-display: block;
}

[class^="icon-"], [class*=" icon-"] {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: 'icomoon' !important;
  speak: never;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-actions:before {
  content: "\\e900";
}

.icon-attributes:before {
  content: "\\e901";
}

.icon-bars:before {
  content: "\\e902";
}

.icon-bell:before {
  content: "\\e903";
  color: #b6b6b6;
}

.icon-bellAlert .path1:before {
  content: "\\e904";
  color: rgb(182, 182, 182);
}

.icon-bellAlert .path2:before {
  content: "\\e905";
  margin-left: -1em;
  color: rgb(245, 96, 96);
}

.icon-calendar:before {
  content: "\\e906";
}

.icon-cemtrik:before {
  content: "\\e907";
  color: #4a4c4d;
}

.icon-changeStatusIcon:before {
  content: "\\e908";
}

.icon-clipboardCheck:before {
  content: "\\e909";
}

.icon-clipboardList:before {
  content: "\\e90a";
}

.icon-clock:before {
  content: "\\e90b";
}

.icon-co:before {
  content: "\\e90c";
}

.icon-expired:before {
  content: "\\e90d";
}

.icon-flag:before {
  content: "\\e90e";
}

.icon-folder:before {
  content: "\\e90f";
}

.icon-globeAltIcon:before {
  content: "\\e910";
}

.icon-graph_indicators:before {
  content: "\\e911";
}

.icon-group:before {
  content: "\\e912";
}

.icon-letter:before {
  content: "\\e913";
  color: #9ca3af;
}

.icon-measuring_points:before {
  content: "\\e914";
}

.icon-reports:before {
  content: "\\e915";
  color: #a5b4fc;
}

.icon-roboot:before {
  content: "\\e916";
}

.icon-transferIcon:before {
  content: "\\e917";
}

.icon-user:before {
  content: "\\e918";
}

.icon-user_point:before {
  content: "\\e919";
}

.icon-vector:before {
  content: "\\e91a";
}

.icon-vector2:before {
  content: "\\e91b";
}
`, "",{"version":3,"sources":["webpack://./src/assets/cemtrik-icons-v1.0/style.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;;EACtB,6CAAqC;;EACrC;;;yDAGuD;;EACvD,mBAAmB;;EACnB,kBAAkB;;EAClB,mBAAmB;AACrB;;AAEA;EACE,+EAA+E;EAC/E,iCAAiC;EACjC,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,cAAc;EAEd,sCAAsC;EACtC,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;AAClB;;AACA;EACE,gBAAgB;AAClB;;AACA;EACE,gBAAgB;AAClB;;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AACA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AACA;EACE,gBAAgB;AAClB;;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AACA;EACE,gBAAgB;AAClB;;AACA;EACE,gBAAgB;AAClB;;AACA;EACE,gBAAgB;AAClB;;AACA;EACE,gBAAgB;AAClB;;AACA;EACE,gBAAgB;AAClB;;AACA;EACE,gBAAgB;AAClB;;AACA;EACE,gBAAgB;AAClB;;AACA;EACE,gBAAgB;AAClB;;AACA;EACE,gBAAgB;AAClB;;AACA;EACE,gBAAgB;AAClB;;AACA;EACE,gBAAgB;AAClB;;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AACA;EACE,gBAAgB;AAClB;;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AACA;EACE,gBAAgB;AAClB;;AACA;EACE,gBAAgB;AAClB;;AACA;EACE,gBAAgB;AAClB;;AACA;EACE,gBAAgB;AAClB;;AACA;EACE,gBAAgB;AAClB;;AACA;EACE,gBAAgB;AAClB","sourcesContent":["@font-face {\n  font-family: 'icomoon';\n  src:  url('fonts/icomoon.eot?w6tg1a');\n  src:  url('fonts/icomoon.eot?w6tg1a#iefix') format('embedded-opentype'),\n    url('fonts/icomoon.ttf?w6tg1a') format('truetype'),\n    url('fonts/icomoon.woff?w6tg1a') format('woff'),\n    url('fonts/icomoon.svg?w6tg1a#icomoon') format('svg');\n  font-weight: normal;\n  font-style: normal;\n  font-display: block;\n}\n\n[class^=\"icon-\"], [class*=\" icon-\"] {\n  /* use !important to prevent issues with browser extensions that change fonts */\n  font-family: 'icomoon' !important;\n  speak: never;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.icon-actions:before {\n  content: \"\\e900\";\n}\n.icon-attributes:before {\n  content: \"\\e901\";\n}\n.icon-bars:before {\n  content: \"\\e902\";\n}\n.icon-bell:before {\n  content: \"\\e903\";\n  color: #b6b6b6;\n}\n.icon-bellAlert .path1:before {\n  content: \"\\e904\";\n  color: rgb(182, 182, 182);\n}\n.icon-bellAlert .path2:before {\n  content: \"\\e905\";\n  margin-left: -1em;\n  color: rgb(245, 96, 96);\n}\n.icon-calendar:before {\n  content: \"\\e906\";\n}\n.icon-cemtrik:before {\n  content: \"\\e907\";\n  color: #4a4c4d;\n}\n.icon-changeStatusIcon:before {\n  content: \"\\e908\";\n}\n.icon-clipboardCheck:before {\n  content: \"\\e909\";\n}\n.icon-clipboardList:before {\n  content: \"\\e90a\";\n}\n.icon-clock:before {\n  content: \"\\e90b\";\n}\n.icon-co:before {\n  content: \"\\e90c\";\n}\n.icon-expired:before {\n  content: \"\\e90d\";\n}\n.icon-flag:before {\n  content: \"\\e90e\";\n}\n.icon-folder:before {\n  content: \"\\e90f\";\n}\n.icon-globeAltIcon:before {\n  content: \"\\e910\";\n}\n.icon-graph_indicators:before {\n  content: \"\\e911\";\n}\n.icon-group:before {\n  content: \"\\e912\";\n}\n.icon-letter:before {\n  content: \"\\e913\";\n  color: #9ca3af;\n}\n.icon-measuring_points:before {\n  content: \"\\e914\";\n}\n.icon-reports:before {\n  content: \"\\e915\";\n  color: #a5b4fc;\n}\n.icon-roboot:before {\n  content: \"\\e916\";\n}\n.icon-transferIcon:before {\n  content: \"\\e917\";\n}\n.icon-user:before {\n  content: \"\\e918\";\n}\n.icon-user_point:before {\n  content: \"\\e919\";\n}\n.icon-vector:before {\n  content: \"\\e91a\";\n}\n.icon-vector2:before {\n  content: \"\\e91b\";\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
